import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, IUtilsDictionary, LoggingService, UtilsJson, UtilsMisc, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { IDtoAppVersion, DtoAppVersion } from '@pit/frontend-model';
import { map, Observable } from 'rxjs';
import { IDtoAppVersionEntityDataService } from '../interfaces/dto.app.version.entity.data.service.interface';

@Injectable({
  providedIn: 'root'
})
export class DtoAppVersionEntityDataService extends EntityDataService<IDtoAppVersion> implements IDtoAppVersionEntityDataService {

  constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
    super(http, null, configService, loggingService);
  }

  public getAppVersionsForMandator$(mandator: string): Observable<IDtoAppVersion[]> {
    return this.httpGet(`/api/web/appversions/mandator/${mandator}`)
      .pipe(map((entities: IDtoAppVersion[]) => {
        const result: IDtoAppVersion[] = [];
        if ((UtilsMisc.isNullOrUndefined(entities) === false) && (entities.length > 0)) {
          for (const entity of entities) {
            result.push(this.createEntityFromJson(entity));
          }
        }
        return result;
      }));
  }

  public async getAppVersionsForMandatorAsync(mandator: string): Promise<IDtoAppVersion[]> {
    return (await this.getAppVersionsForMandator$(mandator).toPromise());
  }

  public saveAppVersionWithFileData$(appVersion: IDtoAppVersion): Observable<IDtoAppVersion> {
    return this.httpPost(`/api/web/appversions`, appVersion, null, (1000 * 60))
      .pipe(map((json: IDtoAppVersion[]) => {
        let result: IDtoAppVersion = null;
        if (UtilsMisc.isNullOrUndefined(json) === false) {
          result = this.createEntityFromJson(json);
        }

        return result;
      }));
  }

  public async saveAppVersionWithFileDataAsync(appVersion: IDtoAppVersion): Promise<IDtoAppVersion> {
    return (await this.saveAppVersionWithFileData$(appVersion).toPromise());
  }

  protected override doGetApiUrl(): string {
    return UtilsString.stringFormat('/api/web/appversions/', this.configurationService.configData.urlApi);
  }

  protected override createEntityFromJson(json: any): IDtoAppVersion {
    const result: IDtoAppVersion = (UtilsJson.deserialize(json, DtoAppVersion) as IDtoAppVersion);
    if (result !== null) {
      result.setReferences();
    }

    return result;
  }

  protected override doGetUrls(): IUtilsDictionary<string> {
    this._urls = super.doGetUrls();

    this._urls.add('get.by.mandator', UtilsString.stringFormat('{0}://{1}:{2}/{3}/mandator/', this.configurationService.configData.protocol, this.configurationService.configData.ip, this.configurationService.configData.port, this.apiUrl) + '{0}');

    return this._urls;
  }

}
